module.exports = __webpack_public_path__ + "i18n/zh-TW.c1ab11e4e37182b93bab0a1e6f36b58f.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-TW.json
// module id = 1548
// module chunks = 60